import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import _ from 'lodash';
import {AccountType, ControlRiskType, HttpStatusCodes, InherentRiskType} from '../../util/uiconstants';
import {normalize, isApiResponseOk, normalizedDelete} from '../../util/utils';

export function accountsReducer(state = initialstate.accounts, action) {
	let newState;
	function mapAccount(account) {
		const mappedAccount = {...account};

		if (account.assertions) {
			mappedAccount.assertions = account?.assertions?.map((assertion) => assertion);
		}

		if (account.entities) {
			mappedAccount.entities = account?.entities?.map((entity) => entity.id);
		}

		return mappedAccount;
	}

	function deleteAccount(accountId) {
		let newState = _.cloneDeep(state);

		// Delete the account from both manageAccounts and root slices
		if (newState.manageAccounts) {
			newState.manageAccounts = normalizedDelete(newState.manageAccounts, accountId);
		}

		newState = normalizedDelete(newState, accountId);
		return newState;
	}

	switch (action.type) {
		case types.GET_ACCOUNTS:
			if (action.response) {
				return action.response.data || state;
			}
			break;
		case types.GET_ACCOUNTS_MANAGE:
			if (action.response && action.response.data) {
				newState = {...state};

				const accountList = normalize(action.response.data.map((account) => mapAccount(account)));
				accountList.pages = action.response.pages;
				accountList.totalEntityCount = action.response.totalEntityCount;

				if (action.isManageAccounts) {
					newState.manageAccounts = {...accountList};
				} else {
					newState = {...accountList};
				}

				return newState;
			}
			return state;
		case types.GET_ALL_ACCOUNTS:
			if (action.response && action.response.data) {
				newState = {...state};

				const accountList = normalize(action.response.data.map((account) => mapAccount(account)));
				accountList.pages = action.response.pages;
				accountList.totalEntityCount = action.response.totalEntityCount;
				newState = {...accountList};
				return newState;
			}
			break;
		case types.UPDATE_ACCOUNT:
			if (action.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteAccount(action?.meta?.api?.data?.accountId);
			} else if (action.response) {
				let newState = _.cloneDeep(state);

				let pspindexids = _.uniq(action.response.pspIndexes?.map((psp) => psp.cgpspIndexID));
				let knowledgeContentIds = _.uniq(action.response.pspIndexes?.map((psp) => psp.knowledgeContentID));
				let pspIndexes = action.meta.pspIndexOptions?.filter(
					(f) => pspindexids?.includes(f.pspIndexId) || knowledgeContentIds?.includes(f.knowledgeContentID)
				);

				pspIndexes?.forEach((e) => {
					(e.pspIndexTitle = e.label), (e.cgpspIndexID = e.pspIndexId);
				});

				newState?.data?.map((m) => {
					if (m.id === action.response.id) {
						m.accountName = action.response.accountName;
						m.accountTypeId = action.response.accountTypeId;
						m.statementTypeId = action.response.statementTypeId;
						m.hasEstimate = action.response.hasEstimate;
						m.assertions = action.response.assertions;
						m.pspIndexes = pspIndexes;
					}
				});
				return newState || state;
			}
			break;
		case types.ADD_NEW_ACCOUNT:
			if (action.response) {
				let newState = _.cloneDeep(state);
				let tempResponse = action.response;

				// response did not contains psp indexes with all properties required so extract psp indexes from original list
				let pspindexids = _.uniq(tempResponse.pspIndexes?.map((psp) => psp.cgpspIndexID));
				let knowledgeContentIds = _.uniq(tempResponse.pspIndexes?.map((psp) => psp.knowledgeContentID));
				let pspIndexes = action.meta.pspIndexOptions?.filter(
					(f) => pspindexids?.includes(f.pspIndexId) || knowledgeContentIds?.includes(f.knowledgeContentID)
				);

				pspIndexes?.forEach((e) => {
					(e.pspIndexTitle = e.label), (e.cgpspIndexID = e.pspIndexId);
				});

				tempResponse.pspIndexes = pspIndexes;

				newState?.data?.push(tempResponse);
				if (newState.totalEntityCount % action.meta.pageSize == 0) {
					newState.pages = newState.pages + 1;
				}
				newState.totalEntityCount = newState?.totalEntityCount + 1;

				return newState || state;
			}
			break;
		case types.CLEAR_ACCOUNTS:
			return initialstate.accounts;

		case types.GET_ACCOUNT_BY_ID:
			// If the account is not found, remove it from the list (concurrency scenario)
			if (action?.error?.response.status === HttpStatusCodes.NotFound) return deleteAccount(action.accountId);
			return state;
		case types.DELETE_ACCOUNT: {
			if (isApiResponseOk(action) || action?.error?.response.status === HttpStatusCodes.NotFound) {
				return deleteAccount(action.accountId);
			}

			return state;
		}
		case types.CREATE_ACCOUNT:
		case types.POST_KNOWLEDGE_ACCOUNT: {
			if (action.response) {
				return {
					...state,
					allIds: state.allIds.concat(action.response.id),
					byId: {
						...state.byId,
						[action.response.id]: {
							...action.response,
							assertions: action.response.assertions ? action.response.assertions.map((assertion) => assertion) : []
						}
					}
				};
			}
			return state;
		}
		case types.POST_ACCOUNT_SCOT_RELATION: {
			if (action.response) {
				return state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		}
		case types.UPDATE_ACCOUNT_SCOT_RELATION: {
			let accounts = _.cloneDeep(state);
			if (accounts.allIds?.includes(action.payload.accountID)) {
				if (
					accounts.byId[action.payload.accountID].scots === undefined ||
					accounts.byId[action.payload.accountID].scots === null
				) {
					accounts.byId[action.payload.accountID].scots = [];
				}
				accounts.byId[action.payload.accountID].scots.push(action.payload);
				accounts.byId[action.payload.accountID].scots.sort((a, b) => a.scotName.localeCompare(b.scotName));
				return accounts;
			} else {
				return state;
			}
		}
		case types.DELETE_SCOT_FROM_ACCOUNT: {
			if (isApiResponseOk(action)) {
				let newAccounts = _.cloneDeep(state);
				if (newAccounts.allIds?.includes(action.meta.accountId)) {
					newAccounts.byId[action.meta.accountId].scots = [
						...newAccounts.byId[action.meta.accountId].scots.filter((scot) => scot.id !== action.meta.scotId)
					];
				}
				return newAccounts;
			} else {
				return state;
			}
		}
		case types.SET_ACCOUNT_LIST_FILTERS: {
			let significantAccounts = _.cloneDeep(state);

			if (significantAccounts.byId) {
				// Filter out the ids
				const filteredIds = significantAccounts.allIds.filter((accountId) => {
					const accountType = significantAccounts.byId[accountId].accountTypeId;
					return accountType === AccountType.Significant || accountType === AccountType.SignificantDiscloure;
				});

				// Create a new byId object without the filtered-out accounts
				const filteredById = filteredIds.reduce((newById, accountId) => {
					newById[accountId] = significantAccounts.byId[accountId];
					return newById;
				}, {});

				// Update the significantAccounts object
				significantAccounts = {
					allIds: filteredIds,
					byId: filteredById
				};
			}
			return significantAccounts;
		}
		case types.UNRELATE_ALL_SCOT_FROM_ACCOUNT_WHEN_DELETED: {
			if (action.scotId !== undefined && action.scotId !== null) {
				let newAccounts = _.cloneDeep(state);
				newAccounts.allIds?.forEach((accountId) => {
					if (newAccounts.byId[accountId].scots) {
						newAccounts.byId[accountId].scots = newAccounts.byId[accountId].scots.filter(
							(scot) => scot.id !== action.scotId
						);
					}
				});
				return newAccounts;
			} else {
				return state;
			}
		}
		case types.GET_ACCOUNTS_WITHOUT_SUBSTANTIVE_PROCEDURE_COUNT:
			if (action.response && action.response.data) {
				const updatedState = {
					...state,
					accountsWithNoSubstantiveTasksCount: action.response.totalEntityCount
				};
				return updatedState;
			}
			break;
		case types.UPDATE_ALL_SCOT_IN_ACCOUNT_LIST_WHEN_SCOT_UPDATED: {
			if (action.scots !== undefined && action.scots !== null) {
				let newAccounts = _.cloneDeep(state);
				newAccounts.allIds?.forEach((accountId) => {
					if (newAccounts.byId[accountId].scots) {
						action.scots.forEach((scot) => {
							newAccounts.byId[accountId].scots?.map((accScot) => {
								if (accScot.id === scot.id) {
									accScot.scotName = scot.scotName;
								}
							});
						});
					}
				});
				return newAccounts;
			} else {
				return state;
			}
		}
		default:
			return state;
	}
}

export function accountsEditReducer(state = initialstate.accounts, action) {
	switch (action.type) {
		case types.GET_ACCOUNTS_EDIT:
			if (action.response) {
				return action.response.data || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		default:
			return state;
	}
}

export function accountAssertionsReducer(state = initialstate.accountAssertions, action) {
	switch (action.type) {
		case types.GET_ASSERTIONS_FOR_ACCOUNTID:
			if (action.response) {
				return action.response || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		default:
			return state;
	}
}

export function accountDetailsReducer(state = initialstate.accountDetails, action) {
	switch (action.type) {
		case types.GET_REVIEWS_FOR_ACCOUNTID:
			if (action.response) {
				return action.response || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		case types.GET_ACCOUNT_BY_ID:
			if (action.response) {
				return action.response || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		case types.CLEAR_ACCOUNT:
			return {};

		default:
			return state;
	}
}

export function removeAccountReviewReducer(state = initialstate.accountDetails, action) {
	switch (action.type) {
		case types.DELETE_REVIEWS_FOR_ACCOUNTID:
			return state;
	}
}
export function addAccountReviewReducer(state = initialstate.accountDetails, action) {
	switch (action.type) {
		case types.ADD_REVIEWS_FOR_ACCOUNTID:
			return action.response;
	}
}

export function currentAccountReducerSEM(state = initialstate.currentAccountSEM, action) {
	switch (action.type) {
		case types.GET_ASSERTIONS_FOR_ACCOUNTID_SEM:
			if (action.response) {
				return action.response || state;
			} else {
				return {
					errorMessage: action.meta.auth.error
				};
			}
		default:
			return state;
	}
}

//TODO: move to a common function in utils.
export function formatAssertionsForDisplayInWcgwTask(
	assertions,
	checkedAssertions = true,
	wcgwWithoutTasksChecked,
	requiredAssertionsChecked,
	acctHasEstimate
) {
	let assertionsToUpdate = _.cloneDeep(assertions);
	let filtered = [];
	/*remove assertions that don't satisfy filter requirements */
	if (requiredAssertionsChecked) {
		assertionsToUpdate.map((assertion) => {
			if (
				assertion.controlRiskTypeId === ControlRiskType.NotRely ||
				(acctHasEstimate === true && assertion.inherentRiskTypeId === InherentRiskType.Higher)
			) {
				filtered.push(assertion);
			}
		});
	} else if (wcgwWithoutTasksChecked) {
		let requiredAssertions = [];
		assertionsToUpdate.map((assertion) => {
			if (
				assertion.controlRiskTypeId === ControlRiskType.NotRely ||
				(acctHasEstimate === true && assertion.inherentRiskTypeId === InherentRiskType.Higher)
			) {
				requiredAssertions.push(assertion);
			}
		});
		let wcgwWithoutTasks = [];
		if (requiredAssertions.length > 0) {
			assertionsToUpdate.map((assertion) => {
				let wcgwIds = assertion.wcgWs?.map((wcgw) => wcgw.id);
				let found = assertion.wcgwTasks?.filter((wcgwTask) => wcgwIds.find((wcgwId) => wcgwId === wcgwTask.id));
				if (!found) {
					wcgwWithoutTasks.push(assertion);
				}
			});
		}
		filtered = wcgwWithoutTasks;
	} else {
		filtered = assertionsToUpdate.sort((a, b) => a.knowledgeAssertionId - b.knowledgeAssertionId);
	}
	if (!checkedAssertions) {
		filtered.map((assertion) => {
			assertion.checked = false;
		});
	}
	if (filtered.length === 5) {
		return filtered;
	}
	if (filtered.length > 0 && filtered.length < 5) {
		let assertionKnowledgeIds = filtered.map((a) => a.knowledgeAssertionId),
			emptyAssertion = {
				assertionName: '',
				assertionAbbreviation: '',
				accountId: 0,
				assertionId: 0,
				inherentRiskTypeId: 0,
				isSystemAssociated: false,
				controlRiskTypeId: 0,
				hasRiskAssociated: false,
				accountName: null,
				knowledgeAssertionId: 6,
				craValue: '',
				validationStatus: null,
				validationMessages: null,
				displayOrder: 0,
				id: 0,
				notForDisplay: true
			};

		if (!assertionKnowledgeIds.some((v) => [6, 1, 10].indexOf(v) !== -1)) {
			filtered.splice(0, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [7, 2, 11].indexOf(v) !== -1)) {
			filtered.splice(1, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [8, 3, 12].indexOf(v) !== -1)) {
			filtered.splice(2, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [4, 13].indexOf(v) !== -1)) {
			filtered.splice(3, 0, emptyAssertion);
		}
		if (!assertionKnowledgeIds.some((v) => [9, 5, 14].indexOf(v) !== -1)) {
			filtered.splice(4, 0, emptyAssertion);
		}
		return filtered;
	}
}
